import React from 'react';
import './Header.css'

function Header() {
    return (
        <div className='container'>
            <div className='links'>
                <label>Anuj kulkarni</label>
            </div>

            <div className='Mars'>
                <label>Images from NASA Mars Rover API</label>
            </div>
        </div>
    )
}

export default Header;
